/** Paths that bypass AuthBootstrap and HRMShell. */
export function isPublicSelfOnboardPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return normalized === '/self-onboard/thank-you' || normalized.startsWith('/self-onboard/');
}

export const SELF_ONBOARD_STORAGE_KEYS = {
  session: 'self_onboard_session',
  setup: 'self_onboard_setup',
  done: 'self_onboard_done',
  completedProfile: 'self_onboard_profile_name',
} as const;

export type SelfOnboardSessionState = {
  sessionId: string;
  token: string;
  maskedEmail?: string;
};

export type SelfOnboardSetupState = {
  setupToken: string;
  sessionId: string;
};

export function readSelfOnboardSession(): SelfOnboardSessionState | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(SELF_ONBOARD_STORAGE_KEYS.session);
    if (!raw) return null;
    return JSON.parse(raw) as SelfOnboardSessionState;
  } catch {
    return null;
  }
}

export function writeSelfOnboardSession(value: SelfOnboardSessionState): void {
  sessionStorage.setItem(SELF_ONBOARD_STORAGE_KEYS.session, JSON.stringify(value));
}

export function readSelfOnboardSetup(): SelfOnboardSetupState | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(SELF_ONBOARD_STORAGE_KEYS.setup);
    if (!raw) return null;
    return JSON.parse(raw) as SelfOnboardSetupState;
  } catch {
    return null;
  }
}

export function writeSelfOnboardSetup(value: SelfOnboardSetupState): void {
  sessionStorage.setItem(SELF_ONBOARD_STORAGE_KEYS.setup, JSON.stringify(value));
}

export function clearSelfOnboardStorage(): void {
  sessionStorage.removeItem(SELF_ONBOARD_STORAGE_KEYS.session);
  sessionStorage.removeItem(SELF_ONBOARD_STORAGE_KEYS.setup);
}

export function markSelfOnboardComplete(firstName?: string): void {
  sessionStorage.setItem(SELF_ONBOARD_STORAGE_KEYS.done, '1');
  if (firstName) {
    sessionStorage.setItem(SELF_ONBOARD_STORAGE_KEYS.completedProfile, firstName);
  }
  clearSelfOnboardStorage();
}

export function hasSelfOnboardCompleted(): boolean {
  return sessionStorage.getItem(SELF_ONBOARD_STORAGE_KEYS.done) === '1';
}

export function readCompletedFirstName(): string | null {
  return sessionStorage.getItem(SELF_ONBOARD_STORAGE_KEYS.completedProfile);
}

export function clearSelfOnboardCompletedFlag(): void {
  sessionStorage.removeItem(SELF_ONBOARD_STORAGE_KEYS.done);
  sessionStorage.removeItem(SELF_ONBOARD_STORAGE_KEYS.completedProfile);
}
